<template>
    <section class="card card-dashboard">
        <div class="card-body" v-if="loader">
            <template>
                <vcl-table :rows="4" :columns="2"></vcl-table>
            </template>
        </div>
        <div class="card-body pb-0" v-show="!loader">
            <div class="row mb-2">
                <div class="col-12 text-right">
                    <el-button type="danger" size="mini" @click="exportStock('pdf')">
                        <i class="fa fa-file-pdf"></i> Exportar PDF
                    </el-button>
                    <el-button type="success" size="mini" @click="exportStock('xlsx')">
                        <i class="fa fa-file-excel"></i> Exportar Excel
                    </el-button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div>
                    <label>Productos por agotarse
                        <el-tooltip class="item" effect="dark" content="Aplica filtro por establecimiento" placement="top-start">
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </label>
                </div>
                <div>
                    <small class="text-danger">Agotado</small>
                    <el-tooltip class="item" effect="dark" content="stock <= 0" placement="top-start">
                        <i class="fa fa-info-circle"></i>
                    </el-tooltip>

                    <small class="text-warning ml-2">Pocas unidades</small>
                    <el-tooltip class="item" effect="dark" content="0 < stock <= stock mínimo" placement="top-start">
                        <i class="fa fa-info-circle"></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="card-body p-0" v-show="!loader">
            <simple-data-table :resource="resource">
                <tr slot="heading">
                    <th>#</th>
                    <th >Código</th>
                    <th >Producto</th>
                    <th class="text-center">Stock</th>
                    <th>Estado</th>
                    <th>Almacén</th>
                    <th class="text-center">Aprovisionar</th>
                </tr>
                <tr slot-scope="{ index, row }">
                    <td>{{ index }}</td>
                    <td  >{{ row.internal_id }}</td>
                    <td  >{{ row.product }}</td>
                    <td class="text-center">{{ row.stock }}</td>
                    <td>
                        <span class="badge bg-danger text-white" v-if="row.state == '01'">Agotado</span>
                        <span class="badge bg-warning text-white" v-if="row.state == '02'">Pocas unidades</span>
                    </td>
                    <td>{{ row.warehouse }} </td>
                    <td  class="text-center">
                        <button type="button" style="min-width: 41px" class="btn waves-effect waves-light btn-xs btn-primary m-1__2"
                                    @click.prevent="clickProvision()"><i class="fa fa-shopping-cart"></i></button>
                    </td>

                </tr>
            </simple-data-table>
        </div>
    </section>
</template>


<script>

    import SimpleDataTable from '../../components/SimpleDataTable.vue'
    import { VclTable } from 'vue-content-loading';

    export default {
        components: {SimpleDataTable, VclTable},
        props: ['establishment'],
        data () {
            return {
                loader: true,
                resource: 'dashboard/stock-by-product',
                records: []
            }
        },
        watch: {
            establishment: {
                immediate: true,
                handler(newVal) {
                    if (newVal) {
                        // Solo emitir cuando tenemos establishment_id
                        this.$eventHub.$emit('reloadSimpleDataTable', newVal)
                    }
                }
            }
        },
        mounted(){
            this.events()
            if (this.establishment) {
                this.$eventHub.$emit('reloadSimpleDataTable', this.establishment)
            }
        },
        created() {
            // this.events()
        },
        methods: {
            events(){
                this.$eventHub.$on('recordsSkeletonLoader', (status) => {
                    this.loader = status
                })

                this.$eventHub.$on('changeStock', (establishment_id) => {
                    this.$eventHub.$emit('reloadSimpleDataTable', establishment_id)
                    // console.log(establishment_id)
                })
            },
            clickProvision(){
                window.open('/purchases/create')
            },

            async exportStock(type) {
                const params = {
                    establishment_id: this.establishment,
                    type
                }
                // const query = new URLSearchParams(params).toString()
                // const url = `dashboard/exports/stock/${type}?${query}`
                // window.open(url, '_blank')

                try {
            
                    const response = await this.$http.post(`/dashboard/exports/stock`, params)
                    console.log(response)
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {
                    console.log(error)
                    this.$message.error(error.message)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/partials/dashboard_stock.vue